import { apiSearchQueryParam } from "components/apiDocs/ApiSidebar/ApiSearchBar";
import { EndPoint } from "components/apiDocs/BrowseAllPage/TagSection";
import { StyledFilteredResultsSection } from "components/apiDocs/BrowseAllPage/style";
import { useCustomerFeedbackModalContext } from "contexts/CustomerFeedbackModalContext";
import { ApiData } from "models/apiDocumentation/apiDocumentationModels";
import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { SearchBarOption, fuzzyApiFilter } from "utils/fuzzyApiHelpers";
import routeConstants from "utils/routeConstants";

import { StyledBody } from "./style";

interface Props {
  apiData: ApiData;
}

const SearchResultsPage: React.FC<Props> = ({ apiData }) => {
  const { open: openCustomerFeedbackModal } = useCustomerFeedbackModalContext();
  const [searchParams] = useSearchParams();

  const allOptions = apiData.endpoints;
  const filterString = searchParams.get(apiSearchQueryParam) ?? "";
  const filteredOptions: SearchBarOption[] = fuzzyApiFilter(
    allOptions,
    filterString
  );

  return filteredOptions.length !== 0 ? (
    <StyledBody>
      <h1>Search results for &apos;{filterString}&apos;</h1>
      <StyledFilteredResultsSection>
        {filteredOptions.map((e) => (
          <EndPoint endpoint={e} key={e.url} />
        ))}
      </StyledFilteredResultsSection>
    </StyledBody>
  ) : (
    <StyledBody data-test-id={"no-results-section"}>
      <h1>No results for &apos;{filterString}&apos;</h1>
      <span>We couldn’t find any matches to your search query.</span>
      <p>
        You can see a list of all available APIs&nbsp;
        <Link to={routeConstants.apiDocs} className="is-link">
          here
        </Link>
        , otherwise feel free to contact us if you have any suggestions to
        improve our service to you.
      </p>
      <span>You can either:</span>
      <ul>
        <li>
          Submit your feedback{" "}
          <a onClick={openCustomerFeedbackModal} className="is-link">
            here
          </a>
        </li>
        <li>Use the ‘Get in touch’ button at the bottom of any page</li>
        <li>
          Email us directly at&nbsp;
          <a href="mailto:insightssupport@elexon.co.uk" className="is-link">
            insightssupport@elexon.co.uk
          </a>
        </li>
      </ul>
    </StyledBody>
  );
};

export default SearchResultsPage;
